import { Component, Input, OnChanges } from '@angular/core';
import { FormErrorInterface } from '../../form-error.interface';

@Component({
    selector: 'form-errors',
    templateUrl: './form-error.component.html',
    styleUrls: ['./form-error.component.scss']
})
export class FormErrorComponent implements OnChanges {

    @Input() for: string;

    @Input() messages: { [key: string]: Array<FormErrorInterface> } | Array<FormErrorInterface> | FormErrorInterface;

    public formErrors: {
        info: Array<{ title?: string, message?: string }>,
        success: Array<{ title?: string, message?: string }>,
        warning: Array<{ title?: string, message?: string }>,
        danger: Array<{ title?: string, message?: string }>,
    };

    constructor() {
        this.setEmptyFormErrorsHolder();
    }

    /**
     * Check if messages need to be updated on every input property change.
     */
    ngOnChanges() {
        this.setEmptyFormErrorsHolder();

        if (this.hasMessages()) {
            this.updateMessages();
        }
    }

    /**
     * Set empty formErrors placeholder.
     */
    private setEmptyFormErrorsHolder() {
        this.formErrors = {
            info: [],
            success: [],
            warning: [],
            danger: [],
        };
    }

    /**
     * Indicates if the messages property contains valid data.
     *
     * @return {boolean}
     */
    private hasMessages() {
        if (this.messages) {
            // Check if the messages property contains a non-empty array
            if (this.messages instanceof Array && this.messages.length) {
                return true;
            }

            // Check if the messages property contains an object with properties
            if (!(this.messages instanceof Array) && Object.keys(this.messages).length) {
                return true;
            }
        }

        return false;
    }

    /**
     * Update the messages.
     */
    private updateMessages() {
        let formErrors = [];

        if (!(this.messages instanceof Array)) {
            // Messages property could contain grouped or a single message

            if (this.for) {
                // We'll assume that the messages property contains a object with groups

                // Get the given group's formErrors
                // Format is now an Array with FormErrors
                formErrors = this.messages[this.for];
            } else {
                // Format is now a single FormError
                // Cast the single formError to an array
                formErrors = [this.messages];
            }
        }

        // Format is now an Array with FormErrors
        if (formErrors instanceof Array) {
            formErrors.forEach((formError: FormErrorInterface) => {
                // Format is now an FormError

                if (!this.formErrors[formError.type]) {
                    throw new Error('Unsupported formError type.');
                }

                // Add to formErrors
                this.formErrors[formError.type].push({
                    title: formError.title,
                    message: formError.message,
                });
            });
        }
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/form-errors/components/form-error/form-error.component.ts